module.exports = __webpack_public_path__ + "img/wall-secure.52313d32.svg";